import React from "react";

const bmpConditionColors: Record<string, { primary: string; muted: string }> = {
  poor: { primary: "var(--condition-poor)", muted: "var(--condition-poor-muted)" },
  fair: { primary: "var(--condition-fair)", muted: "var(--condition-fair-muted)" },
  good: { primary: "var(--condition-good)", muted: "var(--condition-good-muted)" },
  optimal: { primary: "var(--condition-optimal)", muted: "var(--condition-optimal-muted)" },
  unknown: { primary: "var(--condition-unknown)", muted: "var(--condition-unknown-muted)" },
};

export const getBmpConditionColor = (conditionKey: string, muted: boolean = false): string => {
  const normalizedKey = conditionKey.toLowerCase().replace(/\s+/g, "-");
  const colors = bmpConditionColors[normalizedKey] ?? bmpConditionColors.unknown;
  return muted ? colors.muted : colors.primary;
};

const TOP_LIST_OPACITIES = [100, 82, 64, 46, 28];
const TOP_LIST_DARK_TEXT_START_INDEX = 3;

export function getTopListItemStyle(
  index: number,
  listType: "focus" | "comparison",
): React.CSSProperties {
  const baseColor = listType === "focus" ? "var(--chart-1)" : "var(--chart-2)";
  const opacity = TOP_LIST_OPACITIES[index] ?? TOP_LIST_OPACITIES[TOP_LIST_OPACITIES.length - 1];

  return {
    backgroundColor: `color-mix(in srgb, ${baseColor} ${opacity}%, transparent)`,
    color: index >= TOP_LIST_DARK_TEXT_START_INDEX ? "black" : "white",
    borderRadius: "2px",
    padding: "8px",
  };
}

// Adds thousand separators (1,000 and up) wherever a widget shows a count
export const formatNumber = (value: number, decimalPlaces?: number): string =>
  value.toLocaleString(
    "en-US",
    decimalPlaces === undefined
      ? undefined
      : { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces },
  );

// Axis labels only wrap at spaces, so "Pesticides/Herbicides" would be cut off without them
export const addSpacesAroundSlashes = (label: string): string => label.replace(/\s*\/\s*/g, " / ");

export const getTrendIconClass = (
  focusNumber: number | null,
  comparisonNumber: number | null,
  neutralTrendColor: boolean = false,
  upGreenDownRed: boolean = false,
): string | undefined => {
  if (focusNumber !== null && comparisonNumber !== null) {
    if (focusNumber < comparisonNumber) {
      const color = neutralTrendColor ? "grey" : upGreenDownRed ? "red" : "green";
      return `trend-arrow-down-${color}`;
    } else if (focusNumber > comparisonNumber) {
      const color = neutralTrendColor ? "grey" : upGreenDownRed ? "green" : "red";
      return `trend-arrow-up-${color}`;
    } else {
      return "trend-equal";
    }
  }
  return undefined;
};
